import React from 'react';
export function Header() {
  return <header className="w-full bg-white py-2 px-4 sm:px-6 border-b border-gray-200 shadow-sm" data-id="element-340">
      <div className="max-w-4xl mx-auto flex justify-center md:justify-start" data-id="element-341">
        <a href="https://www.neurotoned.com" className="flex items-center" data-id="element-342">
          <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/pocHe1GbsyX8jPLCJ2o1Pu/Healing_isn%E2%80%99t_about_forgetting_%E2%80%94_it%E2%80%99s_about_rewiring.-min.png" alt="Neurotoned Logo" className="h-12 w-12" data-id="element-343" />
        </a>
      </div>
    </header>;
}